import { HttpClient } from '@angular/common/http';
import { MultiTranslateHttpLoader } from './multi-translate-http-loader';
import { environment } from 'src/environments/environment';

export class I18NUtils {
  private static readonly version = btoa(environment.version);

  public static createMultipleLoader(http: HttpClient, bundles: Array<string>) {
    const sources = bundles.map((bundle) => ({
      prefix: `./assets/i18n${bundle}`,
      suffix: `.json?v=${this.version}`,
    }));

    return new MultiTranslateHttpLoader(http, sources);
  }
}
